// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__33RBt","description":"styles_description__yBaZ3","iosButton":"styles_iosButton__2MnSj","close":"styles_close__UtVbP"};